import { render } from "./CGU.vue?vue&type=template&id=35e39c2d&scoped=true"
import script from "./CGU.vue?vue&type=script&lang=js"
export * from "./CGU.vue?vue&type=script&lang=js"

import "./CGU.vue?vue&type=style&index=0&id=35e39c2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e39c2d"]])

export default __exports__